/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { argKey } from 'solis/navigation';


const Args = {};

Args.SourceColony = 'sourceColony';
Args.BoardZone    = 'boardZone';
Args.ColonyZone   = 'zone';

Args.AnchorColony   = 'anchorColony';
Args.AnchorTarget   = argKey(Args.AnchorColony, 'target');
Args.AnchorPosition = argKey(Args.AnchorTarget, 'position');

Args.DeployBoard = 'deployBoard';


export default Object.freeze(Args);
